import { FC, useEffect } from 'react';

import { Link } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { NAVIGATION_TEST_IDS } from '../../test-ids';
import { SkipToContentContainer, SkipToContentWrapper } from './SkipToContent.styles';

export const SkipToContent: FC = () => {
    const { t } = useTranslations();

    useEffect(() => {
        const firstMainElement = document.querySelector('main');
        if (firstMainElement) {
            firstMainElement.setAttribute('id', 'main-content');
        }
    }, []);

    return (
        <SkipToContentWrapper>
            <SkipToContentContainer>
                <Link
                    href="#main-content"
                    variant="text"
                    id="skip-to-main-content"
                    data-test={NAVIGATION_TEST_IDS.SKIP_TO_MAIN_CONTENT_LINK}
                >
                    {t['navbar.skip_to_content']}
                </Link>
            </SkipToContentContainer>
        </SkipToContentWrapper>
    );
};
